<template>
  <div class="construction">
    <section class="top container-fluid">
      <div class="container">
        <div class="row">
          <div class="col-md-7 col-lg-6">
            <h2>Construction Progress</h2>
            <p>Email us at any time to get more information about 293 THE KINGSWAY or to let us know of any comments, questions, or concerns.</p>
            <ul class="contact">
              <li>
                <a href="tel:416-519-6120">
                  <span class="icon">
                    <svg width="14px" height="24px" viewBox="0 0 14 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Version3.3_White@2x" transform="translate(-134.000000, -346.000000)" fill="#ffffff">
                          <g id="Group" transform="translate(134.000000, 346.000000)">
                            <path d="M2.50655022,0 L11.4934498,0 C12.8689956,0 14,1.10447761 14,2.44776119 L14,21.5522388 C14,22.8955224 12.8689956,24 11.4934498,24 L2.50655022,24 C1.13100437,24 0,22.8955224 0,21.5522388 L0,2.44776119 C0,1.10447761 1.13100437,0 2.50655022,0 Z M0.855895197,18.8955224 L13.1441048,18.8955224 L13.1441048,5.10447761 L0.855895197,5.10447761 L0.855895197,18.8955224 Z M13.1441048,19.7313433 L0.855895197,19.7313433 L0.855895197,21.5522388 C0.855895197,22.4477612 1.58951965,23.1940299 2.50655022,23.1940299 L11.4934498,23.1940299 C12.4104803,23.1940299 13.1441048,22.4477612 13.1441048,21.5522388 L13.1441048,19.7313433 Z M0.855895197,4.29850746 L13.1441048,4.29850746 L13.1441048,2.44776119 C13.1441048,1.55223881 12.4104803,0.835820896 11.4934498,0.835820896 L2.50655022,0.835820896 C1.58951965,0.835820896 0.855895197,1.55223881 0.855895197,2.44776119 L0.855895197,4.29850746 Z" id="Shape" fill-rule="nonzero"></path>
                            <path d="M4.34061135,3.10447761 C3.79039301,3.10447761 3.79039301,2.26865672 4.34061135,2.26865672 L9.65938865,2.26865672 C10.209607,2.26865672 10.209607,3.10447761 9.65938865,3.10447761 L4.34061135,3.10447761 Z" id="Path"></path>
                            <path d="M7.09170306,20.119403 C7.79475983,20.119403 8.34497817,20.6865672 8.34497817,21.3432836 C8.34497817,22.0298507 7.79475983,22.5671642 7.09170306,22.5671642 C6.41921397,22.5671642 5.86899563,22.0298507 5.86899563,21.3432836 C5.86899563,20.6865672 6.41921397,20.119403 7.09170306,20.119403 Z" id="Path"></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span class="text">416-519-6120</span>
                </a>
              </li>
              <li>
                <a href="mailto:hello@293kingsway.com">
                  <span class="icon">
                    <svg width="20px" height="14px" viewBox="0 0 20 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Version3.3_White@2x" transform="translate(-132.000000, -390.000000)" fill="#ffffff" fill-rule="nonzero">
                          <g id="Group" transform="translate(132.000000, 390.000000)">
                            <path d="M1.06534091,0.0831232787 C0.484603523,0.0831232787 0,0.565322295 0,1.15177082 L0,12.7777954 C0,13.3642348 0.484603523,13.8536151 1.06534091,13.8536151 L18.9346591,13.8536151 C19.5153964,13.8536151 20,13.3642348 20,12.7777954 L20,1.15177082 C20,0.565322295 19.5153964,0.0831232787 18.9346591,0.0831232787 L1.06534091,0.0831232787 Z M1.640625,1.00115607 L18.359375,1.00115607 L10.6676136,8.29521344 C10.1839343,8.75354131 9.70728545,8.65046918 9.33238636,8.29521344 L1.640625,1.00115607 Z M0.909090909,1.57492656 L6.74005682,7.09746754 L0.909090909,12.3402954 L0.909090909,1.57492656 Z M19.0909091,1.57492656 L19.0909091,12.3402954 L13.2599432,7.09746754 L19.0909091,1.57492656 Z M7.40767045,7.72861508 L8.70738636,8.96222164 C9.3697,9.5898118 10.4919557,9.72090689 11.2926136,8.96222164 L12.5923295,7.72861508 L18.3877841,12.9355823 L1.61221591,12.9355823 L7.40767045,7.72861508 Z" id="Shape"></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span class="text">hello@293kingsway.com</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-md-5 col-lg-6 right">
            <div class="crane">
              <img src="../assets/crane.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="introduction container-fluid">
      <div class="container">
        <div class="row justify-content-between">
          <div class="col-md-12 left-col">
            <h3>Keep up-to-date with <span>293 The Kingsway</span></h3>
          </div>
        </div>
      </div>
      <div class="row pictures">
        <div class="col-12 col-md-5 picture-col">
          <div class="picture" :style="{ backgroundImage: `url('${require('../assets/gallery-1.jpg')}')` }"></div>
        </div>
        <div class="col-md-3 d-none d-md-block picture-col">
          <div class="picture" :style="{ backgroundImage: `url('${require('../assets/gallery-2.jpg')}')` }"></div>
        </div>
        <div class="col-md-4 d-none d-md-block picture-col">
          <div class="picture" :style="{ backgroundImage: `url('${require('../assets/gallery-3.jpg')}')` }"></div>
        </div>
      </div>
    </section>
    <section class="news container-fluid">
      <div class="container">
        <div class="row">
          <div class="col">
            <h3>The latest <span>news &amp; information</span></h3>

            <div class="row update" v-for="post in posts" v-bind:key="post.id">
              <Update>
                <div class="box">
                  <div class="row">
                    <div class="col-md-3 col-lg-2 date-col">
                      <div class="date">
                        <span class="top">{{ months[post.date.getMonth()] }}</span>
                        <span class="middle">{{ padNumber(post.date.getDate()) }}</span>
                        <span class="bottom">{{ post.date.getFullYear() }}</span>
                      </div>
                    </div>
                    <div class="col-md-9 col-lg-10 content-col">
                      <div class="content" v-html="post.content"></div>
                    </div>
                  </div>
                </div>
              </Update>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--<footer class="container-fluid">
      <div class="container">
        <div class="row">
          <div class="col">
            <ul class="contact">
              <li><a href="https://goo.gl/maps/rV3VhoyDfgCqcTu98" target="_blank" rel="noopener noreferrer">293 The Kingsway, Toronto</a></li>
              <!-- <li><a href="tel:416-519-6120">416-519-6120</a></li>
              <li><a href="mailto:hello@293thekingsway.com">hello@293thekingsway.com</a></li>
            </ul>
            <ul class="social">
              <li>
                <a href="http://instagram.com/293kingsway" target="_blank" rel="noopener noreferrer">
                  <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Version3.3_White@2x" transform="translate(-1360.000000, -51.000000)" fill="#A1654A">
                        <g id="Group-5" transform="translate(1360.000000, 51.000000)">
                          <path d="M14.4806047,0 L5.51915865,0 C2.47589642,0 0,2.47601472 0,5.51927695 L0,14.480723 C0,17.5241036 2.47589642,20 5.51915865,20 L14.4806047,20 C17.5241036,20 20,17.5239853 20,14.480723 L20,5.51927695 C20,2.47601472 17.5241036,0 14.4806047,0 Z M18.2256214,14.480723 C18.2256214,16.545646 16.545646,18.2255031 14.480723,18.2255031 L5.51915865,18.2255031 C3.45435402,18.2255031 1.77449693,16.545646 1.77449693,14.480723 L1.77449693,5.51927695 C1.77449693,3.45447232 3.45435402,1.77449693 5.51915865,1.77449693 L14.4806047,1.77449693 C16.5455277,1.77449693 18.2256214,3.45447232 18.2256214,5.51927695 L18.2256214,14.480723 L18.2256214,14.480723 Z" id="Shape" fill-rule="nonzero"></path>
                          <path d="M10,4.70588235 C7.08077956,4.70588235 4.70588235,7.08083408 4.70588235,10.0001215 C4.70588235,12.9192875 7.08077956,15.2941176 10,15.2941176 C12.9192204,15.2941176 15.2941176,12.9192875 15.2941176,10.0001215 C15.2941176,7.08083408 12.9192204,4.70588235 10,4.70588235 Z M10,13.4710365 C8.08605792,13.4710365 6.52880007,11.913986 6.52880007,10 C6.52880007,8.08589245 8.08593639,6.52872039 10,6.52872039 C11.9140636,6.52872039 13.4711999,8.08589245 13.4711999,10 C13.4711999,11.913986 11.9139421,13.4710365 10,13.4710365 Z" id="Shape" fill-rule="nonzero"></path>
                          <path d="M15.2941176,3.52941176 C14.9850267,3.52941176 14.6813904,3.65454545 14.4631016,3.87379679 C14.2437433,4.09197861 14.1176471,4.39572193 14.1176471,4.70588235 C14.1176471,5.01508021 14.2438503,5.31871658 14.4631016,5.53796791 C14.6812834,5.75614973 14.9850267,5.88235294 15.2941176,5.88235294 C15.6042781,5.88235294 15.9069519,5.75614973 16.1262032,5.53796791 C16.3454545,5.31871658 16.4705882,5.01497326 16.4705882,4.70588235 C16.4705882,4.39572193 16.3454545,4.09197861 16.1262032,3.87379679 C15.9080214,3.65454545 15.6042781,3.52941176 15.2941176,3.52941176 Z" id="Path"></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
            </ul>
            <span class="copy">&copy; 2019 MALEN CAPITAL. <span>ALL RIGHTS RESERVED.</span></span>
          </div>
        </div>
      </div>
    </footer>-->
  </div>
</template>

<script>
import axios from 'axios'
import Update from '@/components/Update.vue'

export default {
  name: 'construction',
  data: function () {
    return {
      email: '',
      posts: [],
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
    }
  },
  methods: {
    padNumber: function(number) {
      return number < 10 ? '0' + number : number
    },
  },
  mounted: function () {
    // get all posts
    axios.get('https://wp.293kingsway.com/wp-json/wp/v2/posts?per_page=100&categories=3')
      .then((response) => {
        response.data.forEach((post) => {
          this.posts.push({
            id: post.id,
            date: new Date(post.date_gmt + "+00:00"),
            content: post.content.rendered
          })
        })
      })
      .catch(() => {
        // 
      })
  },
  components: {
    Update
  }
}
</script>

<style lang="scss" scoped>
@import "../stylesheets/variables";

div.construction {
  background-color: #fff;
}

h3 {
  color: black;
  font-weight: 300;
  line-height: 1.3;
  text-transform: uppercase;

  span {
    display: block;
    font-weight: 700;
    color: $red;
  }
}

svg {
  path {
    transition: fill 250ms;
  }
}

section.top {
  background-image: url('../assets/brown-shape.svg'), url('../assets/header.jpg');
  background-size: auto 101%, cover;
  background-position: right top, center center;
  background-repeat: no-repeat;
  background-blend-mode: multiply;
  padding-top: 97px;
  padding-bottom: 94px; 
  background-color: white;
  // margin-top: 95px;
  border-bottom: 8px solid $red;
  position: relative;

  @media all and (max-width: $mediumMax) {
    background-position: 200px top, center center;
  }

  @media all and (max-width: $smallMax) {
    background-size: 100% auto, cover;
    background-position: 160px 101%, center;
  }

  &:before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.33);
  }

  > div.container {
    position: relative;

    div.right {
      display: flex;
      justify-content: center;
      align-items: center;

      @media all and (max-width: $smallMax) {
        padding-top: 40px;
      }

      div.crane {
        background-color: white;
        border-radius: 50%;
        width: 222px;
        height: 222px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: flex-start;

        @media all and (max-width: $smallMax) {
          width: 150px;
          height: 150px;
        }

        img {
          max-width: 66%;
          filter: grayscale(1);
        }
      }
    }
  }

  h2 {
    color: white;
    font-weight: 500;
    font-size: 45px;
    margin: 0 0 20px;

    @media all and (max-width: $mediumMax) {
      font-size: 36px;
    }

    @media all and (max-width: $smallMax) {
      font-size: 36px;
      line-height: 1.3;
      margin-bottom: 40px;
    }
  }

  p {
    font-size: 16px;
    color: white;
    margin: 0 0 40px;
    max-width: 75%;

    @media all and (max-width: $smallMax) {
      max-width: 90%;
    }
  }

  ul.contact {
    list-style: none;
    width: 100%;
    max-width: 250px;
    margin: 0;
    padding: 0;

    li {
      width: 100%;
      padding: 0 0 20px;

      a {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 12px;
        font-weight: 700;
        color: white;
        text-transform: uppercase;
        transition: transform 250ms;

        span.icon {
          width: 20px;
          margin: 0 30px 0 0;
          text-align: center;
          position: relative;
          top: -1px;
        }

        span.text {
          text-align: left;
        }

        &:hover {
          transform: translateY(-5px);
          text-decoration: none;
        }
      }
    }
  }
}

section.introduction {
  padding-top: 50px;

  h3 {
    font-size: 30px;
    margin: 20px 0 0;
    text-align: center;
  }

  div.left-col {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
      font-size: 16px;
      font-weight: 400;
      line-height: 1.625;
      color: #4a4a4a;
      margin: 0;

      @media all and (max-width: $smallMax) {
        margin-bottom: 70px;
      }
    }
  }

  div.right-col {
    position: relative;
  }

  div.box {
    background-color: white;
    padding: 50px 35px;
    box-shadow: 0 30px 100px 0 rgba(105,16,16,0.10);
    width: 100%;

    @media all and (max-width: $mediumMax) {
      top: 40px;
    }

    @media all and (max-width: $smallMax) {
      top: 40px;
      right: auto;
      left: 0;
    }

    h3 {
      font-size: 30px;
      font-weight: 400;
      text-transform: none;
      color: $red;
      line-height: 1.3;
      margin: 0 0 40px;

      @media all and (max-width: $mediumMax) {
        font-size: 24px;
      }

      @media all and (max-width: $smallMax) {
        font-size: 30px;
      }
    }
  }

  div.pictures {
    padding-top: 80px;

    div.picture-col {
      padding-left: 10px;
      padding-right: 10px;

      &:nth-child(1) {
        padding-left: 0;

        @media all and (max-width: $smallMax) {
          padding-right: 0;
        }
      }

      &:nth-child(3) {
        padding-right: 0;
      }
    }

    div.picture {
      background-size: cover;
      background-position: center center;
      width: 100%;
      height: 459px;
      box-shadow: 0 30px 100px 0 rgba(105,16,16,0.10);

      @media all and (max-width: $smallMax) {
        height: 600px;
      }
    }
  }
}

section.news {
  padding-top: 80px;
  padding-bottom: 75px;

  @media all and (max-width: $mediumMax) {
    overflow-x: hidden;
    padding-left: 0;
    padding-right: 0;
  }

  h3 {
    font-size: 30px;
    text-align: center;
    margin: 0 0 70px;
  }

  div.update {
    div.box {
      background-color: white;
      padding: 50px 140px 50px 60px;
      margin-bottom: 25px;
      box-shadow: 0 30px 100px 0 rgba(105,16,16,0.10);

      @media all and (max-width: $mediumMax) {
        padding-right: 60px;
      }

      @media all and (max-width: $smallMax) {
        padding: 50px 20px;
      }

      div.date {
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        @media all and (max-width: $smallMax) {
          margin: 0 auto 50px;
        }

        span.top {
          font-size: 15px;
          padding: 6px 0;
          text-transform: uppercase;
          border-bottom: 1px solid #efefef;
          letter-spacing: 1px;
        }

        span.middle {
          font-size: 44px;
          line-height: 1.25;
          color: $red;
          font-weight: 500;
        }

        span.bottom {
          font-size: 15px;
          display: block;
          text-align: center;
          letter-spacing: 1px;
        }
      }
    }
  }
}

footer {
  background-color: white;
  padding-top: 66px;
  padding-bottom: 77px;

  ul.contact,
  ul.social {
    list-style: none;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;

    @media all and (max-width: $smallMax) {
      flex-direction: column;
    }
  }

  ul.contact {
    margin-bottom: 42px;

    li {
      &:after {
        content: "|";
        margin: 0 15px;
      }

      &:last-child {
        &:after {
          content: "";
          margin: 0;
        }
      }

      a {
        font-size: 16px;
        color: black;
      }

      @media all and (max-width: $smallMax) {
        padding: 6px 0;

        &:after {
          display: none;
        }
      }
    }
  }

  ul.social {
    margin-bottom: 35px;

    li {
      a {
        svg {
          path {
            fill: $red;
          }
        }
      }
    }
  }

  span.copy {
    display: block;
    text-align: center;
    font-size: 14px;
    font-weight: 500;

    span {
      @media all and (max-width: $smallMax) {
        display: block;
      }
    }
  }
}
</style>
<style lang="scss">
@import "../stylesheets/variables";

div.content {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.7;

  @media all and (max-width: $smallMax) {
    font-size: 16px;
  }

  ul,
  ol {
    li {
      margin-bottom: 20px;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }
}
</style>
